module.exports = __webpack_public_path__ + "static/media/french-polynesia.79e6bcc2.png";